export default __webpack_public_path__ + "static/media/174.5dedc637.jpg";